// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"157":"170de0fe","213":"675541ec","453":"7411a835","455":"23a0dd4f","755":"27a46aec"}[chunkId] + ".chunk.js";
};